import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

const GlobalStyle = createGlobalStyle`

  ${normalize}
  html {
    scroll-behavior: smooth;
    background: ${({ theme }) => theme.core.colors.greyscale.white};

  }

  * {
  font-synthesis: none !important;
}
  
  body{

    >div#root {
      display: flex;
      flex-direction: column;

      min-height: 100vh;

    }
     main {
      background: white;
    }

    button,a {
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
    }

    a {
      color:  ${({ theme }) => theme.core.colors.primary.blue.medium};
    }

  }

  && {
    * {
      box-sizing: border-box;
      font-family: 'Jost', sans-serif;
    }

  }

  #modal-container {
  overflow: initial;
}



`;

export default GlobalStyle;
